export default __webpack_public_path__ + "static/ciaran-8360597ec446cc4f2b36b257c6327d0d.jpg";